<template>
    <div>
        <b-list-group>
            <b-list-group-item>
                <b-row align-v="center">
                    <b-col>
                        <h3 class="mb-0">Manuelle Sperrungen &amp; Freigaben</h3>
                    </b-col>
                    <b-col class="pr-4">
                        <b-button
                            @click='show_modalCreate = true'
                            show_modalBlockerFunctionEdit = true
                            size="sm"
                            variant="secondary"
                            class="float-right"
                        >manuelle Sperrung hinzufügen
                        </b-button>
                    </b-col>
                </b-row>
            </b-list-group-item>

            <b-list-group-item v-if="!finishedLoading" align-v="center" class="m-4 p-2">
                <b-col/>
                <b-col align-h="center">
                    <div>
                        <b-spinner style="width: 4rem; height: 4rem;" label="loading..."/>
                    </div>
                </b-col>
                <b-col/>
            </b-list-group-item>

            <b-list-group-item v-for="(currentBlockerManuals, group) in groupedBlockerManuals" v-bind:key="group">

                <b-row>
                    <h6 class="mt-0 ml-3 mb-0" style="line-height: 32px">{{ currentBlockerManuals[0].reason }}</h6>
                    <b-button size="sm" variant="outline-secondary" class="ml-3 my-0"
                        v-b-toggle="'collapse-' + group">
                        ...
                    </b-button>
                </b-row>

                <b-collapse :id="'collapse-' + group">
                    <b-row>
                         <div class="col-2"/>
                    <b-table fixed hover :fields="fields" :items="currentBlockerManuals" size="sm" class="table-sm col-10">
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" variant="secondary" @click="modalDelete.open(row.item.id)" class="mr-1">
                                <span class="icon icon-bin"/>
                            </b-button>
                        </template>
                        <template v-slot:cell(blackOrWhite)="row">
                            <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
                            <span v-else class="text-success">Freigabe</span>
                        </template>
                        <template v-if="finishedLoading" v-slot:cell(place)="row">
                            <span v-if="row.item.countryId">Land <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
                            <span v-else-if="row.item.marketId">Markt <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
                            <span v-else-if="row.item.regionId">Region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
                        </template>
                    </b-table> </b-row>
                </b-collapse>

            </b-list-group-item>

        </b-list-group>

        <b-modal
            v-model="modalDelete.state"
            @ok="modalDelete.ok"
            @hidden="modalDelete.reset"
            centered
        >Wollen sie die Sperrung/Freigabe wirklich löschen?
        </b-modal>

        <b-modal id="modal-blocker-manual-create"
             no-close-on-backdrop
             centered
             cancel-title="Abbrechen"
             v-model="show_modalCreate"
             size="xl"
             :busy="busy_modalCreate"
        ><!-- modal -->
            <template v-slot:modal-title>
                <b-row>
                    <b-input-group class="mx-3">
                        <b-button
                            @click="newBlockerManual.blackOrWhite = !newBlockerManual.blackOrWhite"
                            variant="outline-secondary"
                        ><!-- button -->
                            <span v-if="newBlockerManual.blackOrWhite" class="text-danger">Sperrung</span>
                            <span v-else class="text-success">Freigabe</span>
                        </b-button>
                    </b-input-group>
                </b-row>
            </template>

            <b-container>

                <b-row><h5>Region</h5></b-row>
                <b-row v-for="(regionsPart, idx) in _.chunk(regions, 3)" :key="'r_'+idx">
                    <b-col v-for="region in regionsPart" :key="region.id">
                        <b-form-checkbox
                            v-model="region.selected"
                            :name="`checkbox-region-${region.name}`"
                        ><!-- checkbox -->
                        {{region.name}}
                        <!-- <span v-if="region.selected === false">{{region.name}}</span>-->
                        <!-- <span v-else><b>{{region.name}}</b></span>-->
                        </b-form-checkbox>
                    </b-col>
                </b-row>

                <b-row class="mt-3"><h5>Land</h5></b-row>
                <b-row v-for="(countryPart, idx) in _.chunk(marketCountries, 3)" :key="'l_'+idx">
                    <b-col v-for="country in countryPart" :key="country.id">
                        <b-form-checkbox
                            v-model="country.selected"
                            :name="`checkbox-country-${country.name}`"
                        ><!-- checkbox -->
                        {{country.name}}
                        <!-- <span v-if="country.selected === false">{{country.name}}</span>-->
                        <!-- <span v-else><b>{{country.name}}</b></span>-->
                        </b-form-checkbox>
                    </b-col>
                </b-row>

                <b-row class="mt-3"><h5>Markt</h5></b-row>
              <p>
                <b-form-checkbox
                    :checked="false"
                    :unchecked-value="false"
                    name="checkbox-all-amazon-market"
                    @change="checkAllRelatedMarkets('Amazon', $event)"
                >
                  Amazon Marktplätze
                </b-form-checkbox>
                <b-form-checkbox
                    :checked="false"
                    :unchecked-value="false"
                    name="checkbox-all-amazon-market"
                    @change="checkAllRelatedMarkets('FNAC', $event)"
                >
                  FNAC Marktplätze
                </b-form-checkbox>
                <b-form-checkbox
                    :checked="false"
                    :unchecked-value="false"
                    name="checkbox-all-amazon-market"
                    @change="checkAllRelatedMarkets('Worten', $event)"
                >
                  Worten Marktplätze
                </b-form-checkbox>
              </p>
                <b-row v-for="(marketPart, idx) in _.chunk(markets, 3)" :key="'m_'+idx">
                    <b-col v-for="market in marketPart" :key="market.id">
                        <b-form-checkbox
                            v-model="market.selected"
                            :name="`checkbox-market-${market.identifier}`"
                        ><!-- checkbox -->
                            {{market.name}}
                            <!-- <span v-if="market.selected === true"><b>{{market.name}}</b></span> doesnt work with vue reactivity for some reason -->
                            <!-- <span v-else-if="market.selected === false">{{market.name}}x</span>-->
                        </b-form-checkbox>
                    </b-col>
                </b-row>


                <!-- div class="form-group row my-2">
                    <label class="control-label col-4">Grund</label>
                    <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" :value="blockerManualReasons">
                </div -->

                <b-row class="mt-3">
                    <b-col>
                        <b-form-select
                            size="sm"
                            v-model="newBlockerManual.blockerManualReason"
                            :options="blockerManualReasons"
                            value-field="value"
                            text-field="text"
                            :state="reasonState"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>-- Grund --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col v-if="newBlockerManual.blockerManualReason && newBlockerManual.blockerManualReason.commentRequired">
                        Beschreiben Sie kurz den »{{newBlockerManual.blockerManualReason.reason}}«:
                        <b-input v-model="blockerManualReason_userDescription" :state="validateblockerManualReason_userDescription()"></b-input>
                    </b-col>
                </b-row>
            </b-container>

            <template v-slot:modal-footer>
                <b-button
                    variant="primary"
                    :disabled="(!newBlockerManual.blockerManualReason || !newBlockerManual.blockerManualReason )"
                    @click="save"
                >Ok</b-button>
                <b-button variant="secondary" @click="blockerManualCreate_cancel">Abbrechen</b-button>
            </template>
        </b-modal>

    </div>
</template>
<script>
    import axios from 'axios';
    export default {

        props: [ 'productId', 'materialId', 'asin' ],
        name: "BlockerManualTable",
        data()
        {
            return {
                user: null,
                blockerManualReasons: [],
                blockerManualReason_userDescription: null,
                show_modalCreate: false,
                busy_modalCreate: false, //true during http req. false otherwise, disables OK and cancel buttons
                modalError: {
                    show: false,
                    title: "Speichern",
                    message:
                    "Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden. <p><b>Achtung:</b> laden Sie die Seite neu, um sicherzugehen, dass die angezeigten Daten mit den Serverdaten übereinstimmen.</p>",
                    error: ""
                },

                modalDelete: {
                    state: false,
                    blockerManualId: null,
                    open: (id) =>
                    {
                        this.modalDelete.blockerManualId = id;
                        this.modalDelete.state = true;
                    },
                    ok: () =>
                    {
                        let dumpId = this.modalDelete.blockerManualId; // we need this bc reset is being triggered before axios delete request reports back.
                        let blockerManual = this.blockerManuals.find( b => b.id === dumpId );
                        axios.delete(`${this.urlRoot}/blocker_manual`, { data: { blockerManual: blockerManual, materialId: this.materialId } } ).then( () =>
                        {
                            this.blockerManuals = this.blockerManuals.filter( b => b.id != dumpId);
                            this.groupBlockers();
                            this.modalDelete.blockerManualId = null;
                            this.$emit('saveEvent');
                        }).catch( error =>
                        {
                            console.log("got here");
                             this.modalError = {
                                show: true,
                                title: "Speichern",
                                message:
                                "Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden. <p><b>Achtung:</b> laden Sie die Seite neu, um sicherzugehen, dass die angezeigten Daten mit den Serverdaten übereinstimmen.</p>",
                                error: error.toString()
                            };
                            console.log(error);
                            this.modalDelete.blockerManualId = null;
                        });

                    },
                    reset: () =>
                    {
                        this.modalDelete.blockerManualId = null;
                    }
                },
                urlRoot: '/mds',
                finishedLoading: false,
                countries: [],
                regions: [],
                markets: [],
                allAmazonMarketsSelected : false,
                marketCountries: [], //separate from markets, bc map markets->countries is surjective.
                blockerManuals: [],
                groupedBlockerManuals: {},
                countrySelectOptions: [],
                regionSelectOptions: [],
                marketSelectOptions: [],
                marketSort: [ //Prod
                    1, 2, 22, 5, 6, 11, 8, 9, 7, 3, 4, 25
                ],

                // marketSort: [ // DEV markets, DO NOT USE IN PROD!
                //     1,
                //     2,
                //     22
                // ],
                fields: [
                  { key: 'reason', label: 'Grund' },
                  { key: 'blackOrWhite', label: 'Art' },
                  { key: 'username', label: 'Benutzer' },
                  { key: 'updatedAt',    label: 'geändert am', formatter: (s) => (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '-'},
                  { key: 'place', label: 'Region' },
                  { key: 'actions', label: '' },
                ],
                placeOptions: ["Markt", "Region", "Land"],
                newBlockerManual: {
                    reason: "",
                    blackOrWhite: 1,
                    productId: this.productId
                },
                //for some reason, this prop cannot be inside of selectedBF, changes aren't handled correctly.
                newBlockerManualPlace: 'country',
                reasonState: null
            }
        },
        /*
        computed: {
            selectedReason: function() {
                return this.blockerManualReasons.find( x => x.reason == this.newBlockerManual.reason);
            }
        },*/
        watch: {

        },
        methods: {
            blockerManualCreate_cancel() {
                console.log("+++ blockerManualCreate_cancel");
                this.show_modalCreate = false;
                alert("Vorgang abgebrochen.");
                this.resetAllFields();
            },
            hashCode(s) {
                if(s === null) return 0;
                var hash = 0, i, chr;
                if (s.length === 0) return hash;
                for (i = 0; i < s.length; i++) {
                    chr   = s.charCodeAt(i);
                    hash  = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return Math.abs(hash);
            },
            validateblockerManualReason_userDescription() {
                return (this.blockerManualReason_userDescription != null && this.blockerManualReason_userDescription.length > 0);
            },
            groupBlockers()
            {
                this.groupedBlockerManuals = _.groupBy(this.blockerManuals, blocker => this.hashCode(blocker.reason) );
            },
            save(evt)
            {
                this.busy_modalCreate = true;
                evt.preventDefault();
                // copy object because of the translation mess.

                if(![...this.marketCountries, ...this.markets, ...this.regions].some( x => x.selected ))
                {
                    alert("sie müssen mindestens ein Häkchen (Region, Land, Markt) setzen.");
                    return;
                }

                if(this.newBlockerManual.blockerManualReason.reason == "")
                {
                    this.reasonState = false;
                    return;
                }

                let request = {
                    asin: this.asin,
                    reason: this.newBlockerManual.blockerManualReason.reason,
                    black_or_white: this.newBlockerManual.blackOrWhite,
                    username: this.user.name,
                    material_id: this.materialId,
                    country_ids: this.marketCountries.filter( c => c.selected ).map( c => c.id ),
                    market_ids: this.markets         .filter( m => m.selected ).map( m => m.id ),
                    region_ids: this.regions         .filter( r => r.selected ).map( r => r.id )
                };

                let promises = [axios.post(`${this.urlRoot}/blocker_manual/bulk`, request)];

                if(this.newBlockerManual.blockerManualReason.commentRequired)
                {
                    // add a History entry for Katalogfehler BlockerManualReason
                    let request = {
                        material_id: this.materialId,
                        product_id: this.productId,
                        username: this.user.name,
                        reason: this.newBlockerManual.blockerManualReason.reason,
                        description: this.blockerManualReason_userDescription
                    }
                    promises.push(axios.post("/blocker_manual_reason/material_reason", request));
                }

                Promise.all(promises)
                .then( () => {
                    this.busy_modalCreate = false;
                    //fetch new blockerManuals, for ease.
                    axios.get(`${this.urlRoot}/blocker_manual/by_asin/${this.asin}`).then( response => {
                        this.blockerManuals = response.data;
                        this.groupBlockers();
                    }).catch( error => {
                        console.log(error);
                        alert("Fehler beim speichern. Blocker WURDE NICHT GESPEICHERT!");
                    });

                    this.$emit('saveEvent');

                    this.newBlockerManual = {
                        reason: "",
                        blackOrWhite: 1,
                        // productId: parseInt(this.productId),
                        asin: this.asin
                    }
                    this.reasonState = null;
                    this.marketCountries.forEach( country => { country.selected = false });
                    this.markets.forEach( market => { market.selected = false });
                    this.regions.forEach( region => { region.selected = false });
                    this.show_modalCreate = false;
                    this.$bvModal.hide('modal-blocker-manual-create');
                    this.resetAllFields();
                }).catch( error => {
                    this.busy_modalCreate = false;
                    this.show_modalCreate = true;
                    console.log(error);
                    alert("Fehler beim speichern. Blocker WURDE NICHT GESPEICHERT!");
                });
            },
            resetAllFields() {
                this.marketCountries = this.marketCountries.map( x => { x.selected = false; return x });
                this.markets = this.markets.map( x => { x.selected = false; return x });
                this.regions = this.regions.map( x => { x.selected = false; return x });
                this.blockerManualReason_userDescription = null;
                this.newBlockerManual = {
                    reason: "",
                    blackOrWhite: 1,
                    productId: this.productId
                };
            },
            isAmazonComparator(v,w) {
                if(v.isAmazonAccount === w.isAmazonAccount) {
                    return v.name.localeCompare(w.name)
                } else if(v.isAmazonAccount) {
                    return -1;
                }
                return 1;
            },
            checkAllRelatedMarkets(marketName, event) {
              const isChecked = event
                this.markets = this.markets.map( market => {
                    if(market.name.includes(marketName)) {
                        market.selected = isChecked;
                    }
                    return market;
                });
            }
        },
        mounted()
        {
            let promises = [
                ['country', 'market', 'region'].map( s => axios.get(`${this.urlRoot}/${s}`)),
                axios.get(`/mds/blocker_manual/${this.productId}`),
                axios.get('/blocker_manual_reason/all'),
                axios.get('/user/self')
            ].flat();

            Promise.all(promises).then(([_countries, _markets, _regions, _blockerManuals, _blockerManualReasons, _user]) =>
            {
                this.finishedLoading = true;
                this.blockerManuals = _blockerManuals.data;
                this.groupBlockers();
                this.countries = _countries.data;
                this.markets = _markets.data;
                this.blockerManualReasons = _blockerManualReasons.data.map( x => { return { text: x.reason, value: x } });
                // console.log("_blockerManualReasons", _blockerManualReasons);
                this.user = _user.data;
                for (let market of this.markets)
                {
                    let country = this.countries.find(country => country.id === market.countryId);
                    country.selected = false;
                    if( (market.identifier.substr(0, 4) === 'AMZ-') || RegExp("amazon", "i").test(market.name))
                    {
                        country.isAmazonAccount = true;
                        market.isAmazonAccount = true;
                    }
                    else if( country.isAmazonAccount === undefined )
                    {
                        country.isAmazonAccount = false;
                    }

                    let twin = this.marketCountries.find( other => other.id === country.id );

                    if( twin )
                    {
                        twin.isAmazonAccount = twin.isAmazonAccount || country.isAmazonAccount;
                    }
                    else
                    {
                        this.marketCountries.push(_.cloneDeep(country));
                    }
                }

                this.marketCountries.sort( this.isAmazonComparator );
                this.markets.sort( this.isAmazonComparator );

                let dump = [];
                for( let marketId of this.marketSort )
                {
                    let market = this.markets.find( x => x.id === marketId );
                    if(market)
                    {
                        dump.push(market);
                    }
                }
                this.markets.forEach( x => {
                    x.selected = false;
                    if(!dump.find( y => y.id === x.id)) {
                        dump.push(x);
                    }
                });

                this.markets = dump;

                this.regions = _regions.data;
                this.regions.forEach( region => { region.selected = false });
            })
            .catch( error => console.log(error) );
        }
    }
</script>
